export default "<p *ngFor=\"let item of dropdownData\" (click)=\"itemClicked(item)\">{{ item.value }}</p>\n"